import axios from "@/http";

class Project {
  /* 根据仓库id和权限搜索项目 */
  static getProjectListByWarehouseAndAuth(warehouseId) {
    const url = `/oa/api/project/list/by/warehouse/have?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 根据仓库id搜索项目 */
  static getProjectListByWarehouse(warehouseId) {
    const url = `/oa/api/project/list/by/warehouse?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Project